'use strict';

var _ = require('lodash');

var configHandler = {};

configHandler.setConfig = function (data, config, GUID, generated) {

  _.each(config.dynamicColumns, function (newColumn) {
    config.columns[newColumn.target.id] = newColumn.target;
    if (newColumn.source) config.columns[newColumn.source.id].active = newColumn.source.active;
  });

  var colOrder = 0;
  _.each(config.columns, function (d, key) {
    d.column = { id: key };
    if (!d.header) d.header = key;
    if (!d.exclude) d.exclude = false;

    if (!d.group) d.group = 'undefined';
    if (!config.columnGroups) config.columnGroups = {};
    if (!config.columnGroups[d.group]) {
      config.columnGroups[d.group] = { order: colOrder++ };
    }

    if (!d.order || !d.active) d.order = config.columnGroups[d.group].order;
  });

  // Delete possible GUID columns
  if (GUID) {
    if (config.columns['GUID']) delete config.columns['GUID'];
  }
  if (config.columns['patientID']) delete config.columns['patientID'];

  if (config.cohortSelection) {
    if (config.columns[config.cohortSelection.column.id]) {
      config.columns[config.cohortSelection.column.id].exclude = true;
      config.columns[config.cohortSelection.column.id].active = false;
    };
  };

  var stateData = {};

  stateData['config'] = {};
  if (config.logiReportID) stateData['config']['logiReportID'] = config.logiReportID;

  stateData['config']['GUID'] = GUID;
  stateData['config']['generated'] = generated;
  stateData['config']['minSampleSize'] = config.minSampleSize;
  stateData['config']['columnGroups'] = config.columnGroups;
  stateData['config']['columns'] = _.sortBy(config.columns, function (o) {
    return o.order;
  });
  stateData['config']['dynamicColumns'] = config.dynamicColumns;
  stateData['config']['cohortSelector'] = false;
  if (config.cohortSelection) stateData['config']['cohortSelector'] = config.cohortSelection;
  if (config.localTextAPI) stateData['config']['localTextAPI'] = config.localTextAPI;

  stateData['activePatient'] = null;
  stateData['parallelPlot'] = _.cloneDeep(stateData['config']['columns']);
  stateData['patients'] = [];
  stateData['patientsIdMap'] = {};
  stateData['filters'] = { patients: [], categories: {} };

  if (config.outcomeInsights) stateData.outcomeInsights = config.outcomeInsights;

  stateData['validationWarnings'] = {
    patientIsOutlier: false,
    patientIsOutFilterSelection: false,
    sampleSizeTooSmall: false,
    invalidInput: false
  };

  return stateData;
};

configHandler.getGeneratedConfig = function (data, GUID) {

  var config = {
    "activePatient": null,
    "minSampleSize": 30,
    "GUID": GUID,
    "graphType": "parallelPlot",
    "columnGroups": {},
    "dynamicColumns": [],
    "columns": {},
    "outcomeInsights": { "cards": [] },
    "ordered": false
  };

  config.columnGroups = {
    "undefined": { "order": 0, "label": "Undefined" },
    "demographics": { "order": 1, "label": "Demographics" },
    "preTreatment": { "order": 2, "label": "Pre Treatment" },
    "diagnosis": { "order": 3, "label": "Diagnosis" },
    "prediction": { "order": 4, "label": "Predictions" },
    "treatment": { "order": 5, "label": "Treatment" },
    "postTreatment": { "order": 6, "label": "Post Treatment" },
    "threshold": { "order": 7, "label": "Threshold | Other" }
  };

  config.cohortSelection = null;

  _.each(data, function (value, key) {

    if (value === "") {
      data[key] = 'NA';
    }
    var v = Number(value);
    var scale = void 0;

    if (isNaN(v)) {
      scale = { "scaling": "categorical", "order": "category" };
    } else {
      scale = { "scaling": "continuous", "domain": "extent", "type": "lineair" };
    }

    config.columns[key] = {
      "group": "undefined",
      "scale": scale,
      "header": key,
      "mapCategoryLabel": null,
      "active": false,
      "filter": null,
      "labelPrefix": null,
      "exclude": null
    };
  });

  return config;
};

module.exports = configHandler;